"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createJsonLayout = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const JsonLayout_1 = require("./JsonLayout");
const createJsonLayout = (options) => {
    const Component = () => (react_1.default.createElement(JsonLayout_1.JsonLayout, Object.assign({}, options)));
    Component.displayName = 'JsonLayoutWrapper';
    return Component;
};
exports.createJsonLayout = createJsonLayout;
